<template>
  <div v-if="pwa.deferredPrompt.value" class="bot-express-alert" :class="{ 'show-alert': isVisible }">
    <div class="alert-content">
      <div class="bot-icon">
        <img src="/favicon.ico" />
      </div>
      
      <div class="alert-text">
        <h3>{{ title }}</h3>
        <p>{{ description }}</p>
      </div>
      
      <button class="download-button" @click="handleDownload">
        <span class="download-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
        </span>
        {{ buttonText }}
      </button>
      
      <button v-if="showCloseButton" class="close-button" @click="closeAlert" aria-label="Fechar">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { usePWA } from '@/composables/usePWA'
import { ref, defineProps, defineEmits } from 'vue'

const pwa = usePWA()

const props = defineProps({
  title: {
    type: String,
    default: 'Baixe o Bot Express agora!'
  },
  description: {
    type: String,
    default: 'Para mais recursos e automação, baixe nosso Bot Express diretamente.'
  },
  buttonText: {
    type: String,
    default: 'Download'
  },
  showCloseButton: {
    type: Boolean,
    default: true
  },
  autoHideAfter: {
    type: Number,
    default: 0 // 0 means don't auto-hide
  }
})

const emit = defineEmits(['download', 'close'])
const isVisible = ref(true)

const closeAlert = () => {
  isVisible.value = false
  emit('close')
}

const handleDownload = () => {
  pwa.install()
}

// Auto-hide functionality
if (props.autoHideAfter > 0) {
  setTimeout(() => {
    closeAlert()
  }, props.autoHideAfter)
}
</script>

<style scoped>
.bot-express-alert {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #1a1a1a;
  border-top: 1px solid #333;
  z-index: 9999;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
}

.bot-express-alert::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, #34d399, #34d599 );
}

.show-alert {
  transform: translateY(0);
}

.alert-content {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  max-width: 1400px;
  margin: 0 auto;
  gap: 12px;
}

.bot-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bot-icon svg {
  width: 100%;
  height: 100%;
}

.alert-text {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.alert-text h3 {
  color: #fff;
  font-size: 0.95rem;
  margin: 0;
  font-weight: 600;
  line-height: 1.2;
}

.alert-text p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
  margin: 0;
  line-height: 1.3;
}

.download-button {
  background-color: #34d399;
  color: #000;
  border: none;
  border-radius: 30px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 32px;
}

.download-button:hover {
  background-color: #32ad80;
  transform: translateY(-2px);
}

.download-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  margin-left: 4px;
}

.close-button:hover {
  color: rgba(255, 255, 255, 0.8);
}

@media (max-width: 640px) {
  .alert-text h3 {
    font-size: 0.85rem;
  }
  
  .alert-text p {
    font-size: 0.75rem;
  }
  
  .download-button {
    padding: 6px 12px;
    font-size: 0.8rem;
    height: 28px;
  }
  
  .bot-icon {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 480px) {
  .alert-content {
    padding: 8px 12px;
  }
  
  .alert-text p {
    display: none;
  }
}
</style>